import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router';

import { Toaster } from '@/components/ui/toaster';
import { ThemeProvider } from '@/lib/components/theme-provider';
import { SESSION_STORAGE_KEYS } from '@/lib/constants/sessionStorageKeys';

import { MaintenanceBanner } from '../components/LayoutBanner/MaintenanceBanner';
import Loader from '../components/Loader';
import { useInitializePermissionsStore } from '../stores/useInitializePermissionsStore';
import Meta from './Meta';
import Sidebar from './Sidebar';

const Layout = () => {
  // since this is the dashboard layout, we dont have a policy id, so we pass undefined as policyId
  // this will only initialize the current user store
  useInitializePermissionsStore({ policyId: undefined });

  useEffect(() => {
    // this is a guard to prevent the user from accessing the dashboard page with a sequence_id
    // this will only apply, if the user types the url manually, without ending the time travel mode
    const sequenceData = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.SEQUENCE_ID
    );
    if (sequenceData) {
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.SEQUENCE_ID);
      window.location.reload();
    }
  }, []);

  return (
    <ThemeProvider>
      <Meta />
      <div className="flex h-screen flex-col overflow-hidden dark:bg-black dark:text-white">
        {/* <Header /> */}
        <Sidebar />
        <div className="flex min-h-0 flex-1 flex-col pl-[20vw]">
          <main className="flex min-h-0 flex-1 flex-col p-6 sm:p-8">
            <MaintenanceBanner />
            {/* TODO: See if shads class "wrapper" is better */}
            {/* TODO: Add fallback component */}
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </main>
          <Toaster />
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
